import s from './page-template.module.scss'
import classNames from 'classnames'

export const PageTemplate = ({
	title,
	hideTitleOnTablet = false,
	hideTitleOnMobile = false,
	fullHeight = true,
	children,
	className,
	titleClassName,
	contentClassName,
	whiteOnMobile = false,
	scrollContentOnMobile = false
}) => {
	return (
		<div className={classNames(s.wrapper, fullHeight && s.fullHeight, className, whiteOnMobile ? s.whiteOnMobile : '')}>
			{title && (
				<h1 className={classNames(
					s.title,
					hideTitleOnTablet && s.hideTitleOnTablet,
					hideTitleOnMobile && s.hideTitleOnMobile,
					titleClassName
				)}>
					{title}
				</h1>
			)}
			<div className={classNames(s.content, contentClassName, scrollContentOnMobile ? s.scrollContentOnMobile : '')}>
				{children}
			</div>
		</div>
	)
}
